var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-2" },
    [
      _c(
        "div",
        { staticClass: "pa-2 mb-2 bordered-element" },
        [
          _c(
            "v-tabs",
            {
              staticStyle: { "z-index": "1" },
              attrs: {
                "background-color":
                  _vm.$vuetify.theme.themes[_vm.theme].background
              },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c("v-tab", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.generateMessage("requests.details.titles.HO")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("v-tab", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.generateMessage("requests.details.titles.HNO")) +
                    "\n      "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              style: {
                background: _vm.$vuetify.theme.themes[_vm.theme].background
              },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c("v-tab-item", [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("custom-simple-table", {
                      staticStyle: { width: "60%" },
                      attrs: {
                        item: _vm.property.contractual_commitment,
                        "i18-path":
                          "properties_360.fields.contractual_commitment",
                        "table-units": "hour",
                        "table-keys": ["intervention_limit", "request_limit"]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column px-2" },
                      [
                        _c("display-checkbox", {
                          attrs: {
                            label: _vm.generateMessage(
                              "properties_360.fields.contractual_commitment.request_included"
                            ),
                            "input-value":
                              _vm.property.contractual_commitment
                                .request_included
                          }
                        }),
                        _vm._v(" "),
                        _c("display-checkbox", {
                          attrs: {
                            label: _vm.generateMessage(
                              "properties_360.fields.contractual_commitment.on_call"
                            ),
                            "input-value":
                              _vm.property.contractual_commitment.on_call
                          }
                        }),
                        _vm._v(" "),
                        _c("display-checkbox", {
                          attrs: {
                            label: _vm.generateMessage(
                              "properties_360.fields.contractual_commitment.contract_wh_enabled"
                            ),
                            "input-value":
                              _vm.property.contractual_commitment
                                .contract_wh_enabled
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("v-tab-item", [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("custom-simple-table", {
                      staticStyle: { width: "60%" },
                      attrs: {
                        item: _vm.property.contractual_commitment,
                        "table-units": "hour",
                        "i18-path":
                          "properties_360.fields.contractual_commitment",
                        "table-keys": [
                          "intervention_limit_nwh",
                          "request_limit_nwh"
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column px-2" },
                      [
                        _c("display-checkbox", {
                          attrs: {
                            label: _vm.generateMessage(
                              "properties_360.fields.contractual_commitment.request_included_nwh"
                            ),
                            "input-value":
                              _vm.property.contractual_commitment
                                .request_included_nwh
                          }
                        }),
                        _vm._v(" "),
                        _c("display-checkbox", {
                          attrs: {
                            label: _vm.generateMessage(
                              "properties_360.fields.contractual_commitment.on_call"
                            ),
                            "input-value":
                              _vm.property.contractual_commitment.on_call
                          }
                        }),
                        _vm._v(" "),
                        _c("display-checkbox", {
                          attrs: {
                            label: _vm.generateMessage(
                              "properties_360.fields.contractual_commitment.contract_nwh_enabled"
                            ),
                            "input-value":
                              _vm.property.contractual_commitment
                                .contract_nwh_enabled
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("custom-simple-table", {
        attrs: {
          item: _vm.property.contractual_commitment,
          "i18-path": "properties_360.fields.contractual_commitment",
          "table-keys": ["intervention_hours"]
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }